// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__vLtIb","chip__recorded":"Chip_chip__recorded__wztRg","chip__live":"Chip_chip__live__HpU47"};